<template>
  <div class="hello" id="detailDom">
    <Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>

    <!-- 退出登陆提醒 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">{{ languageJson.OperationTips }}</div>
        </div>
        <div
            style="position: absolute;width: 100%;top: 35%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
          {{ languageJson.ExitText }}</div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
        </div>
      </div>
    </el-dialog>

    <!-- 图片放大 -->
    <el-dialog :visible.sync="ifPic" center class="img-user">
      <div style="background: black">
        <img style="width: 100%" :src="picUrl" class="mapImg" >
      </div>
    </el-dialog>

    <div class="enentDiv">
      <div style="width: 100%;">
        <div style="height: 70px;display: flex;align-items: center;justify-content: flex-start;">
          <div style="margin-left: 30px;">
          <el-button @click="toIndex">返回</el-button>
          </div>
          <div style="margin-left: 5px;">
            <el-select  v-model="oilId"  placeholder="请选罐体" @change='searchFun'>
              <el-option v-for="(item, $index) in 34" :key="$index" :label="'罐体'+($index+1)" :value="$index+1+''">
              </el-option>
            </el-select>
          </div>
          <div style="margin-left: 5px;">
            <el-date-picker v-model="searchDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                            @change='searchFun'>
            </el-date-picker>
          </div>
        </div>

        <div style="width: calc(100% - 60px);text-align: center;margin-left: 30px;">
          <el-table :data="dataList" :cell-style="{borderColor:'#4D95DA'}"
                    :header-cell-style="{background: '#124086',borderColor: '#4D95DA'}"
                    :row-style="{background: 'rgb(27,48,71)',color: '#5BC5FF'}">

            <el-table-column label="序号" align="center" type="index"></el-table-column>

            <el-table-column label="设备名称" prop="deviceName" align="center"></el-table-column>

            <el-table-column label="罐体状态" align="center">
              <template slot-scope="scope">
                  {{statusMap[scope.row.oilType]}}
              </template>
            </el-table-column>

            <el-table-column label="设备开关" align="center">
              <template slot-scope="scope">
                {{ scope.row.deviceStatus=='1' ? '开' : '关' }}
              </template>
            </el-table-column>

            <el-table-column label="识别开关" align="center">
              <template slot-scope="scope">
                {{ scope.row.identifyStatus=='1' ? '开' : '关' }}
              </template>
            </el-table-column>

            <el-table-column label="上报时间" prop="createTime" align="center"></el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <span @click="viewPic(scope.row.picUrl)" style="cursor: pointer" >查看图片</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div style="text-align: right;margin-right: 25px;margin-top: 10px;">
          <el-pagination layout="total, prev, pager, next" :current-page='page' :total="total"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import {
  getInspectionRecords
} from '@/api/admin.js'
import {
  getItem,
  setToken,
  setItem,
  removeItem,
  removeToken
} from '@/utils/auth'

export default {
  name: "detail",
  components: {
    Head,
  },
  data() {
    return {
      dataList:[],
      ifPic:false,
      picUrl:null,
      oilId: this.$route.query.oilId ,
      total: 0,
      page: 1,
      searchDate: this.getNowTime(),
      statusMap:{"1":"调和","2":"灌装","3":"循环","4":"加热"},
      languageJson: languageJson,
      tapType: false,
      dialogVisible: false,


    }
  },

  mounted() {
    this.searchFun();
  },


  methods: {
    viewPic(url){
      this.picUrl = url;
      this.ifPic = true;
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      return defaultDate;
    },
    handleCurrentChange(val) {
      this.page = Number(val)
      console.log(this.page)
      this.searchFun(val)
    },
    searchFun(val) {
      if(!val){
        this.page =1;
      }
      let param = {
        oilId:this.oilId,
        date:this.searchDate,
        pageNo: this.page,
        pageSize: 10
      }
      console.log(param)
      getInspectionRecords(param).then(res => {
        this.total = res.data.total;
        this.dataList = res.data.data;
        console.log(res)
      })
    },

    toIndex(){
      this.$router.push({
        name: 'oil',
      })
    },

    changeTap(data) {
      this.tapType = data
    },
    headOut(data) {
      this.dialogVisible = true
    },
    getOut() {
      removeToken()
      removeItem('differtime')
      removeItem('loginSuccess')
      this.dialogVisible = false
      this.$router.push({
        name: 'login'
      })
    }
  },

}
</script>

<style scoped lang="less">
/deep/ .el-table th>.cell {
  color: #9CC3FF;
}
/deep/ .el-table::before {
  content: '';
  position: absolute;
  background-color: rgb(77, 149, 218);
  z-index: 1;
}
/deep/ .el-pager li {
  background: rgb(27, 48, 71);
  color: #9CC3FF;
}
/deep/ .el-pager li.active {
  color: #409EFF;
  cursor: default;
}
/deep/ .el-pagination .btn-prev {
  color: #9CC3FF;
  background: center center no-repeat rgb(27, 48, 71);
}
/deep/ .el-pagination .btn-next {
  color: #9CC3FF;
  background: center center no-repeat rgb(27, 48, 71);
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
  background: center center no-repeat #000000;
}
/deep/ .el-input__inner {
  background: #124086;
  border: 1px solid #124086;
  color: #9CC3FF;
}
/deep/.el-button {
  background: #124086;
  color: #9CC3FF;
  border: none;
}
/deep/ .el-pagination__total {
  color: #9CC3FF;
}
/deep/ .el-dialog__header {
   padding: 0;
}
/deep/ .el-dialog--center .el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-pagination {
  background: #020f3d;
}
/deep/ .el-table__empty-block {
  background: rgb(27, 48, 71);;
}
///deep/ .el-table td, .el-table th.is-leaf:first-child {
//  border-right:none;
//  border-left: 1px solid;
//}
///deep/ .el-table td, .el-table th.is-leaf {
//  border: 1px solid;
//}
</style>


// WEBPACK FOOTER //
// src/page/oil/record.vue